import { render, staticRenderFns } from "./WaterWOInfoTypeCard.vue?vue&type=template&id=36aedb1c&"
import script from "./WaterWOInfoTypeCard.vue?vue&type=script&lang=js&"
export * from "./WaterWOInfoTypeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports